import H2 from "../atoms/typography/H2"
import { Col, Container, Row, Visible } from "react-grid-system"
import { theme } from "../theme"
import { HorizontalSpacer } from "../atoms/spacers"
import { MailIcon } from "../atoms/icons/MailIcon"
import Body from "../atoms/typography/Body"
import Button from "../atoms/buttons/Button"
import Inputbox from "../molecules/input/Inputbox"
import React from "react"
import { useSignUpForNews } from "../../graphql/mutations/useSignUpForNews"
import H3 from "../atoms/typography/H3"

const SignUpForNewsForm: React.FunctionComponent = () => {
  const [email, setEmail] = React.useState<string>()
  const { signUpForNews, data, error, loading } = useSignUpForNews()
  const isSent = data?.signUpForNews.success

  if (error) {
    return <H3>Something went wrong..</H3>
  }

  if (isSent) {
    return (
      <div>
        <H2>Thank you for your interest in Satcube!</H2>
        <HorizontalSpacer spacing={1} />
        <Body>You will receive an email within short.</Body>
      </div>
    )
  }

  return (
    <div>
      <H2>Would you like to get the latest news from Satcube?</H2>
      <HorizontalSpacer spacing={2} />
      <Body>Enter your email address to stay connected!</Body>
      <HorizontalSpacer spacing={2} />
      <Row align="center">
        <Col>
          <Inputbox
            label="Email"
            placeholder="Your email address"
            onChange={(value) => setEmail(value)}
            value={email}
          />
        </Col>
        <Visible xs sm>
          <Col xs={12}>
            <HorizontalSpacer spacing={2} />
          </Col>
        </Visible>
        <Col xs={12} md="content">
          <Button
            onPress={() => signUpForNews({ variables: { email, url: window.location.href } })}
            title="Subscribe"
            size="normal"
            variant="green"
            disabled={loading}
            iconLeft={<MailIcon color={theme.colors.white} />}
          />
        </Col>
      </Row>
    </div>
  )
}

export default SignUpForNewsForm
